import { useState, useEffect } from "react";
import "./AppSidebar.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { APP_MENUS, selectUIStates, setUIStates } from "../../../redux/features/appData";

type AppSidebarProps = {

}

export const AppSidebar = ({} : AppSidebarProps) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const uiStates = useSelector(selectUIStates)

    return (
        <div className="app-sidebar">
            <div className="app-sidebar-section">
                Manage
            </div>

            <div 
                className="app-sidebar-item"
                onClick={() => {
                    dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.EMPLOYEES}));
                    navigate("/app/employee-records")
                }}
            >
                Employees
            </div>

            <div 
                className="app-sidebar-item"
                onClick={() => {
                    dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.EMPLOYEE_NEW}));
                    navigate("/app/employee-records/new")
                }}
            >
                Add Employee
            </div>

            <div 
                className="app-sidebar-item"
                onClick={() => {
                    dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.TIME_OFF}));
                    navigate("/app/time-off")
                }}
            >
                Time Off
            </div>

            <div 
                className="app-sidebar-item"
                onClick={() => {
                    dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.FLATTEN}));
                    navigate("/app/employee-records/flatten")
                }}
            >
                Flatten
            </div>

            <div 
                className="app-sidebar-item"
                onClick={() => {
                    dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.DOCUMENTS}));
                    navigate("/app/documents")
                }}
            >
                Documents
            </div>

            <div className="app-sidebar-section">
                Admin
            </div>
            <div 
                className="app-sidebar-item"
                onClick={() => {
                    dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.CUSTOM_PROPERTIES}));
                    navigate("/app/custom-properties/")
                }}
            >
                Customize Properties
            </div>

            <div className="app-sidebar-section">
                You
            </div>

            <div 
                className="app-sidebar-item"
                onClick={() => {
                    dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.TIME_OFF}));
                    navigate("/app/employee/time-off")
                }}
            >
                Time Off
            </div>

            <div 
                className="app-sidebar-item"
                onClick={() => {
                    dispatch(setUIStates({...uiStates, appSelectedMenu: APP_MENUS.EMPLOYEE_CALENDAR}));
                    navigate("/app/employee/calendar")
                }}
            >
                Calendar
            </div>

           
        </div>
    )
}